import { connect } from 'react-redux';
import TagSearch from './tagSearch';
import { bindActionCreators } from 'redux';
import { tagSearch,auditLogs } from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
    tagInfo: state.siteListingReducer.tagInfo,
    tagAudit: state.siteListingReducer.tagAudit
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      tagSearch,
      auditLogs
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(TagSearch);
